/**
 * Footer newsletter — Klaviyo list subscription (Email List). No Shopify fallback.
 */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function initFooterNewsletter(root) {
    var form = root.querySelector('form');
    if (!form || form.dataset.newsletterBound) return;
    form.dataset.newsletterBound = "true";
    var strings = JSON.parse(root.dataset.formStrings);

    var companyId = root.getAttribute('data-klaviyo-public-key');
    var listId = root.getAttribute('data-klaviyo-list-id');
    var useKlaviyo = !!(companyId && listId && window.LoftsailsKlaviyo);

    var emailInput = form.querySelector('input[type="email"]');
    var submitBtn = form.querySelector('[type="submit"]');
    var formFields = root.querySelector('[data-footer-newsletter-fields]');
    var successEl = root.querySelector('[data-footer-newsletter-success]');
    var errorEl = root.querySelector('[data-footer-newsletter-error]');

    function showError(msg) {
      if (errorEl) {
        errorEl.textContent = msg;
        errorEl.hidden = false;
      }
    }

    function hideError() {
      if (errorEl) errorEl.hidden = true;
    }

    function showSuccess() {
      if (formFields) formFields.hidden = true;
      if (successEl) successEl.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitBtn?.disabled) return;
      hideError();

      var email = (emailInput && emailInput.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        showError(strings.email);
        if (emailInput) emailInput.focus();
        return;
      }

      if (!useKlaviyo) {
        showError(strings.unavailable);
        return;
      }

      if (submitBtn) submitBtn.disabled = true;

      window.LoftsailsKlaviyo.subscribeToList(companyId, listId, {
        email: email,
        properties: { Source: 'Footer' }
      }, { source: 'Footer newsletter' }).then(function () {
        window.LoftsailsKlaviyo.identifyProfile({ $email: email, Source: 'Footer' });
        showSuccess();
      }).catch(function (err) {
        console.error('Footer newsletter Klaviyo error:', err);
        if (submitBtn) submitBtn.disabled = false;
        showError(strings.error);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-footer-newsletter]').forEach(initFooterNewsletter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
